require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-5-tips-for-becoming-a-mortgage-pro.json") })
        }
      }, "path---articles-5-tips-for-becoming-a-mortgage-pro");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-5-tips-for-becoming-a-mortgage-pro!./.cache/json/articles-5-tips-for-becoming-a-mortgage-pro.json
// module id = 1548
// module chunks = 231608221292675